module.exports = __webpack_public_path__ + "static/media/F1Logo.e60a1a78.png";